// removed by extract-text-webpack-plugin
module.exports = {"wasabi-modal-container":"wasabi-modal-container","active":"active","wasabi-overlay":"wasabi-overlay","wasabi-modal":"wasabi-modal","fadein":"fadein","modal":"modal","wasabi-modal-close":"wasabi-modal-close","wasabi-modal-header":"wasabi-modal-header","wasabi-modal-content":"wasabi-modal-content","wasabi-modal-footer":"wasabi-modal-footer"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Layout/Modal.scss
// module id = 243
// module chunks = 0